export default __webpack_public_path__ + "static/will_girten-7377f0102f05cb156d075e93fe53e484.jpg";